import { Divider as ChakraDivider, DividerProps } from '@chakra-ui/react';

const Divider = ({ orientation = 'horizontal', ...props }: DividerProps) => (
  <ChakraDivider orientation={orientation} opacity={1} {...props} />
);

export default Divider;
